import React from 'react';
import './css/VersionDisplay.css';

const VersionDisplay = ({ version = '', updated }) => (
  <h2 className="VersionDisplay">
    {/* eslint-disable-next-line */}
    Accurate as of WordPress version {version}. (Last update: {updated})
  </h2>
);

export default VersionDisplay;
